import { isEqual } from "lodash";
import {
  UPDATE_VIDEO_PARAMS,
  RESET_FILTERS_VIDEOS,
  fetchVideos,
} from "./VideoActions";
import { _nullParams } from "./VideoReducers";

export default (store) => (next) => (action) => {
  const { videoParams } = store.getState();

  if (action.type === UPDATE_VIDEO_PARAMS) {
    if (!isEqual(videoParams, action.params) && !action.params.updateParamsOnly) {
      store.dispatch(fetchVideos({ ...videoParams, ...action.params }));
    }
  }

  if (action.type === RESET_FILTERS_VIDEOS) {
    store.dispatch(
      fetchVideos({ ...videoParams, filters: _nullParams.filters })
    );
  }

  return next(action);
};
